import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { STATUS_CODE } from '@drl/core/api/error-code';
import { environment } from '@drl/env/environment';
import { get } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IpsTranslateService } from '../localization/ips-translate.service';
import { UserSessionStoreService as StoreService } from '@drl/core/store/user-session-store.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { NgxPermissionsService } from 'ngx-permissions';

export const ErrToastSkipHeader = 'X-Skip-Error-Toast';
const errorMsgConst = 'error.error.message.message';
const unknownErr = 'Unknown Error';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly toastrService: ToastrService,
    protected readonly translateSvc: IpsTranslateService,
    private readonly store: StoreService,
    private readonly permissionsService: NgxPermissionsService,
    private readonly router: Router
  ) { }

  private _checkTokenExpiryErr(error: HttpErrorResponse): boolean {
    return (
      error.status &&
      error.status === STATUS_CODE.UNAUTHORIZED &&
      get(error, 'error.error.message') === 'TokenExpiredError'
    );
  }

  private _checkActiveSessionErr(error: HttpErrorResponse): boolean {
    const bool = (
      error.status &&
      error.status === STATUS_CODE.UNAUTHORIZED &&
      get(error, 'error.error.message') === 'ActiveSessionFound'
    );
    return bool;
  }

  private _checkTokenRevokedErr(error: HttpErrorResponse): boolean {
    const bool = (
      error.status &&
      error.status === STATUS_CODE.UNAUTHORIZED &&
      get(error, 'error.error.message') === 'TokenRevokedError'
    );
    return bool;
  }

  private _handleTokenRevokedErr(): void {
    this.store.clearAll();
    this.permissionsService.flushPermissions();
    this.router.navigate(['/login']);
  }

  intercept(
    // sonarignore:start
    req: HttpRequest<any>,
    // sonarignore:end
    next: HttpHandler,
    // sonarignore:start
  ): Observable<HttpEvent<any>> {
    const errorTitle = this.translateSvc.translate.instant('errorLbl');
    // sonarignore:end
    if (req.headers.has(ErrToastSkipHeader)) {
      const headers = req.headers.delete(ErrToastSkipHeader);
      return next.handle(req.clone({ headers }));
    } else if (
      req.url.endsWith('/logout') ||
      req.url.endsWith('/token-refresh')
    ) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        catchError((error, caught) => {
          if (
            error instanceof HttpErrorResponse &&
            error.error &&
            error.error.error &&
            error.error.error.statusCode &&
            error.error.error.statusCode === STATUS_CODE.UNPROCESSABLE_ENTITY
          ) {
            const errMsg = this.getErrMsg(error);
            this.toastrService.error(errMsg, errorTitle, {
              timeOut: environment.messageTimeout,
            });
          }
          else if (error && this._checkActiveSessionErr(error)) {
            this.store.setActiveSessionModal(true);
          } 
          else if (error && this._checkTokenExpiryErr(error)) {
          }
          else if(this._checkTokenRevokedErr(error)){
            this._handleTokenRevokedErr();
          }
          else if (
            error instanceof HttpErrorResponse &&
            !this._checkTokenExpiryErr(error)
          ) {
            let errMsg = get(error, errorMsgConst);
            errMsg =
              errMsg ||
              get(
                error,
                'error.error.message',
                this.translateSvc.translate.instant('errorMsgLbl'),
              );
            if(!(error.statusText && error.statusText === unknownErr) || !(errMsg === this.translateSvc.translate.instant('errorMsgLbl'))){
              this.toastrService.error(errMsg, errorTitle, {
                timeOut: environment.messageTimeout,
              });
            }
          }  
                    else if (error && error.statusText) {
            this.toastrService.error(
              this.translateSvc.translate.instant(error.statusText),
              errorTitle,
              {
                timeOut: environment.messageTimeout,
              },
            );
          } else {
            // redundant else block
          }

          throw error;
        }),
      );
    }
  }

  getErrMsg(err) {
    const errDetails = get(err, 'error.error.details');
    let errMsg: string;
    if (errDetails && errDetails.length) {
      errDetails.forEach(item => {
        if (errMsg) {
          errMsg = `${errMsg} \
          ${item.path} ${item.message}`;
        } else {
          errMsg = `${item.path} ${item.message}`;
        }
      });
    }

    return errMsg;
  }
}
